export default __webpack_public_path__ + "static/media/suitemaster_6.b6e39f07.jpg";